import { Collapse } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './logs.module.scss';
const { Panel } = Collapse;
import { Box, SmallSection } from '../../../components/design';
import { formatDate, formatDateTime, formatPrice } from '../../../library/utils';
import { getCurrencyById } from '../../../library/helpers/currency';
import DocumentsDownloader from '../../template/documentDownloader';
import { getFilePath } from '../../../library/constants';

const Price = ({ price, currency }) => {
    if (!price) {
        return 'NA'
    }
    return (
        <>
            <div>{formatPrice(price, currency)}</div>
        </>
    )
}
Price.propTypes = {
    price: PropTypes.number,
    currency: PropTypes.oneOf(['EUR', 'GBP', 'USD']).isRequired,
}
const statusName = (status) => {
    const statuses = {
        1: 'Active',
        2: 'Send',
        3: "Visual Request",
        4: "Response from Leopriting",
        5: 'Cancelled',
        6: "Approved"
    }
    return statuses[status]
}
const getStatus = (status) => {
    return status == 1 ? <div className={styles.active}>{statusName(status)}</div> : <div className={styles.inactive}>{statusName(status)}</div>
}


const QuotationLogs = ({ logs, active, statusData }) => {
    const itemId = active?.item.id;
    const projectId = active?.item?.project_id ;
    return <Collapse  expandIconPosition="end" defaultActiveKey={"1"}>
        <Panel header='Quotation Logs' key="1">
            <div className={styles.activityLogs}>
                <h3>Active Quotation</h3>
                <div>
                    {active.status == 4 ?
                        active?.request_files.map((value) => {
                            return (
                                <div key={value.name}>
                                    <DocumentsDownloader name={value.name} comment={value?.comment} image={value.url} item_id={active.item_id} project_id={active?.item?.project_id} />
                                </div>
                            )
                        })
                        :
                        active.file ?
                            <Box type={Box.BoxTypes.GRAY} header={
                                <div className={styles.formGrid}>
                                    <h4>Type</h4>
                                    <h4>File Name</h4>
                                    <h4></h4>
                                    <h4>Current Status</h4>
                                </div>
                            } footer={
                                <div>
                                    <p>Comment :{statusData?.filter(data => data.status == active.status)[0]?.comment}</p>
                                    <p>Created at : {formatDateTime(active?.createdAt)}</p>
                                </div>}>
                                <SmallSection colorLight={'#F1F1F1'} colorDark={'#BABABA'} >
                                    <div className={styles.gridValues}>
                                        <div>File</div>
                                        <div>{active.file?.quotation?.name}</div>
                                        <div><a target='blank' href={getFilePath(active.file?.quotation?.url,projectId,itemId)}>Downlaod</a></div>
                                        <div>{getStatus(active.status)}</div>
                                    </div>
                                </SmallSection>

                            </Box> :
                            <Box type={Box.BoxTypes.GRAY} header={
                                <div className={styles.formGrid}>
                                    <h4>Quantity</h4>
                                    <h4>Artowrk Approval Date</h4>
                                    <h4>Purchase Price</h4>
                                    <h4>Shipping Price</h4>
                                    <h4>Current Status</h4>
                                </div>
                            } footer={
                                <div>
                                    <p>Comment :{statusData?.filter(data => data.status == active.status)[0]?.comment}</p>
                                    <p>Created at : {formatDateTime(active?.createdAt)}</p>
                                </div>}>

                                {(active.status == 1 || active.status == 2 || active.status == 3) && active?.item_vendor_quotation_prices && active?.item_vendor_quotation_prices.map((qData) => {
                                    return <SmallSection key={qData.id} colorLight={'#F1F1F1'} colorDark={'#BABABA'} >
                                        <div className={styles.gridValues}>
                                            <div>{qData.quantity}</div>
                                            <div>{formatDate(qData.expected_artwork_received_date)}</div>
                                            <div>{<Price price={qData.price_unit} currency={active.currency?.code} />}</div>
                                            <div> <Price price={qData.transport_price} currency={active.currency?.code} /></div>
                                            <div>{getStatus(qData.status)}</div>
                                        </div>
                                    </SmallSection>

                                })}
                            </Box>
                    }
                    <br />
                </div>
                {logs.length > 0 && <h3>Quotation History</h3>}
                {logs.map((qData) => {
                    return <div key={qData.id}>
                        <div>
                            {/* <p className='smallText'>Created At : {logs == null ? '' : qData.createdAt}</p>
                                <p className='smallText'>Current status : {logs == null ? '' : statusName(qData.status)}</p> */}
                            {
                                qData.status == 3 || qData.status == 1 || qData.status == 2 || qData.status == 5 ?
                                    <div>
                                        <Box type={Box.BoxTypes.GRAY} header={
                                            <div className={styles.formGrid}>
                                                <h4>Quantity</h4>
                                                <h4>Artowrk Approval Date</h4>
                                                <h4>Purchase Price</h4>
                                                <h4>Shipping Price</h4>
                                                <h4>Current Status</h4>
                                            </div>

                                        } footer={
                                            <div>
                                                <p>Comment : {qData.comment}</p>
                                                <p>Created at : {formatDateTime(qData.createdAt)}</p>
                                            </div>
                                        } >{qData.item_vendor_quotation_prices.map((value) => {
                                            return (<SmallSection colorLight={'#F1F1F1'} colorDark={'#BABABA'} key={value?.id}>
                                                <div className={styles.gridValues}>
                                                    <div>{value.quantity}</div>
                                                    <div>{formatDate(value.expected_artwork_received_date)}</div>
                                                    <div>{<Price price={value.price_unit} currency={getCurrencyById(qData.currency_id)?.code} />}</div>
                                                    <div> <Price price={value.transport_price} currency={getCurrencyById(qData.currency_id)?.code} /></div>
                                                    <div>{getStatus(qData.status)}</div>
                                                </div>
                                            </SmallSection>)
                                        })}
                                        </Box>
                                        <br />
                                    </div> :
                                    qData.status == 4 &&
                                    qData.request_files.map((value) => {
                                        return (
                                            <div key={value.name}>
                                                <DocumentsDownloader name={value.name} comment={value?.comment} image={value.url} item_id={qData.item_id} project_id={qData?.item?.project_id} />
                                            </div>
                                        )
                                    })
                            }

                        </div>
                    </div>
                })}
            </div>
        </Panel>
    </Collapse >
}
QuotationLogs.propTypes = {
    logs: PropTypes.arrayOf(PropTypes.object).isRequired,
    active: PropTypes.object.isRequired,
    statusData: PropTypes.arrayOf(PropTypes.object).isRequired
}
export default QuotationLogs